import { SvgIcon } from '@mui/material';
import React from 'react';

const EditColoredIcon = props => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12.2733 3.86668L11.4667 3.06001C10.9467 2.54001 10.1 2.54001 9.58 3.06001L7.79333 4.84668L2 10.64V13.3333H4.69333L10.52 7.50668L12.2733 5.75335C12.8 5.23335 12.8 4.38668 12.2733 3.86668ZM4.14 12H3.33333V11.1933L9.10667 5.42001L9.91333 6.22668L4.14 12ZM7.33333 13.3333L10 10.6667H14V13.3333H7.33333Z"
        fill={props.color}
      />
    </SvgIcon>
  );
};

export default EditColoredIcon;
